import React, { useState } from 'react';

import Segmented, { SegmentedOption } from 'components/DesignSystem/Segmented';
import SelectorChip from 'components/DesignSystem/SelectorChip';
import { NumericForecastImage } from 'helper/products/meteorology';
import ForecastDaysRange from '../ForecastDaysRange';
import SingleMap from './SingleMap';
import GridDays from './GridDays';

import './index.scss';

const MODE_OPTIONS: SegmentedOption<'single' | 'grid'>[] = [
  { value: 'single', icon: 'crop_square', ariaLabel: 'Ver um dia por vez' },
  { value: 'grid', icon: 'grid_view', ariaLabel: 'Ver sequência de dias' },
];

export default function SpatialDisplay({
  images,
  models,
  gridMode,
  setGridMode,
  periodLabel,
  dateLabel,
}: {
  images: NumericForecastImage[];
  models: string[];
  gridMode: boolean;
  setGridMode: (value: boolean) => void;
  periodLabel?: string;
  dateLabel?: string;
}) {
  const [selectedModel, setSelectedModel] = useState(models[0]);
  const currentModel = models.includes(selectedModel) ? selectedModel : models[0];
  const currentImage = images.find(
    (image) => image.model.toLowerCase() === currentModel.toLowerCase(),
  );

  return (
    <div className="tf-pnt-mobile-spatial">
      <div className="tf-pnt-mobile-spatial-toolbar">
        <div className="tf-pnt-mobile-spatial-pills">
          {models.map((model) => (
            <SelectorChip
              key={model}
              className="tf-pnt-mobile-spatial-pill"
              selected={model === currentModel}
              onClick={() => setSelectedModel(model)}
            >
              {model}
            </SelectorChip>
          ))}
        </div>
      </div>
      <div className="tf-pnt-mobile-spatial-nav-card">
        {periodLabel && (
          <div className="tf-pnt-mobile-spatial-nav-header">
            <span>{`Previsão ${periodLabel}`}</span>
            {dateLabel && (
              <span className="tf-pnt-mobile-spatial-nav-date">
                {` - ${dateLabel}`}
              </span>
            )}
          </div>
        )}
        <div className="tf-pnt-mobile-spatial-nav-row">
          {!gridMode && <ForecastDaysRange />}
          <Segmented
            className="tf-pnt-mobile-spatial-mode-switch"
            size="sm"
            fill={false}
            ariaLabel="Modo de visualização"
            options={MODE_OPTIONS}
            value={gridMode ? 'grid' : 'single'}
            onChange={(next) => setGridMode(next === 'grid')}
          />
        </div>
      </div>
      {gridMode
        ? <GridDays model={currentModel} images={images} />
        : <SingleMap image={currentImage} />}
    </div>
  );
}
